import { render } from "./MagentoPrices.vue?vue&type=template&id=b81ba5fa"
import script from "./MagentoPrices.vue?vue&type=script&lang=js"
export * from "./MagentoPrices.vue?vue&type=script&lang=js"

import "./MagentoPrices.vue?vue&type=style&index=0&id=b81ba5fa&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__